import '@stimulus/polyfills'
import { Application, Controller } from 'stimulus'
import '@splidejs/splide/css'
import { Splide } from '@splidejs/splide'

const app = Application.start()

app.register('refosumu--companies-index--reform-examples-section', class extends Controller {
  static targets = ['sliderPc', 'sliderSp']

  connect() {
    this.initializeSliders()
  }

  initializeSliders() {
    // PC用カルーセル
    if (this.hasSliderPcTarget) {
      const pcSlides = this.sliderPcTarget.querySelectorAll('.splide__slide')
      const pcSlideCount = pcSlides.length

      const pcConfig = {
        type: pcSlideCount > 3 ? 'loop' : 'slide',
        gap: '24px',
        pagination: false,
        arrows: pcSlideCount > 3,
        perPage: 3,
        perMove: 3,
      }

      const pcSplide = new Splide(this.sliderPcTarget, pcConfig)
      pcSplide.mount()
    }

    // SP用カルーセル
    if (this.hasSliderSpTarget) {
      const spSlides = this.sliderSpTarget.querySelectorAll('.splide__slide')
      const spSlideCount = spSlides.length

      const spConfig = {
        type: spSlideCount > 1 ? 'loop' : 'slide',
        pagination: false,
        arrows: spSlideCount > 1,
        height: 'auto',
        fixedHeight: true,
        focus: 'center',
        autoWidth: true,
      }

      const spSplide = new Splide(this.sliderSpTarget, spConfig)
      spSplide.mount()
    }
  }
})
